import { z } from 'zod/v4';

export const DeleteOrderParamsSchema = z.object({
  id: z.string().min(1),
});

export type DeleteOrderParams = z.infer<typeof DeleteOrderParamsSchema>;

/** Error codes the delete answers with, besides `not_found`. */
export const DELETE_ORDER_ERROR_CODES = {
  /**
   * 400 — the caller's company did not create the order, or the order has no
   * tracing link of its own.
   */
  UNABLE_TO_DELETE: 'unable_to_delete',
} as const;
